import React from 'react';
import { useTranslation } from 'react-i18next';

// L'ENCREUAMENT.
//
// Dos fils d'ordit i dos de trama, passant l'un per sobre de l'altre. Els vuit traços són quatre
// línies **tallades**: cada tall és el punt on l'altre fil passa per damunt, i alternen com en un
// teixit de debò (tafetà). No és una quadrícula amb forats; és l'entrellaçat, que és el que vol
// dir la paraula que dona nom a l'aplicació.
//
// Es dibuixa amb `currentColor` a posta: així serveix igual damunt de blanc, de negre i de
// l'accent, sense tres fitxers. I el gruix del traç puja quan la mida baixa, perquè a 16 px un
// traç de 1,7 desapareix —el favicon és on es moren els logotips—.
export function Simbol({ mida = 24, className = '' }) {
  const gruix = mida <= 16 ? 2.4 : mida <= 28 ? 1.9 : 1.7;
  return (
    <svg width={mida} height={mida} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth={gruix} strokeLinecap="round" className={className}
         role="img" aria-label="TRAMA">
      {/* ordit */}
      <path d="M9 3 V13.2" /><path d="M9 16.8 V21" />
      <path d="M15 3 V7.2" /><path d="M15 10.8 V21" />
      {/* trama */}
      <path d="M3 9 H7.2" /><path d="M10.8 9 H21" />
      <path d="M3 15 H13.2" /><path d="M16.8 15 H21" />
    </svg>
  );
}

// El símbol amb el nom al costat. `tagline` només a la pantalla d'entrada: a la barra superior
// hi ha l'aplicació sencera a sota i no cal explicar què és cada cop.
export function Marca({ mida = 22, tagline = false, className = '' }) {
  const { t } = useTranslation();
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <Simbol mida={mida} className="text-primary-700 flex-shrink-0" />
      <div className="leading-tight">
        <div className="font-bold tracking-wide text-primary-700"
             style={{ fontSize: Math.round(mida * 0.86) }}>
          {t('brand.name')}
        </div>
        {tagline && (
          <div className="text-gray-500" style={{ fontSize: Math.max(10, Math.round(mida * 0.42)) }}>
            {t('brand.tagline')}
          </div>
        )}
      </div>
    </div>
  );
}

export default Marca;
